import { OrderItemInfo } from 'appTypes/orders'
import groupBy from 'lodash/groupBy'

export const combineDividedComplementaryItems = (orderItems: OrderItemInfo[]): OrderItemInfo[] => {
  const groupedItems = groupBy(orderItems, (value) => value.orderItem.productId)

  return Object.values(groupedItems)
    .map<OrderItemInfo[]>((sameItemIdItems) => {
      // if there is only one item with provided id
      if (sameItemIdItems.length === 1) {
        return sameItemIdItems
      }

      // if item is not complementary
      if (!sameItemIdItems[0].orderItem.productData?.complementary) {
        return sameItemIdItems
      }

      const groupedComplementary = groupBy(sameItemIdItems, (value) => value.orderItem.rentedFrom)

      const reducedComplementary = Object.values(groupedComplementary).map((sameRentedFromItems) =>
        sameRentedFromItems.reduce<OrderItemInfo>(
          (prev, curr) => ({ ...prev, amount: prev.orderItem.amount + curr.orderItem.amount }),
          {
            orderItem: { ...sameRentedFromItems[0].orderItem, amount: 0 },
            prolongations: sameRentedFromItems[0].prolongations,
            location: sameRentedFromItems[0].location,
            manager: sameRentedFromItems[0].manager,
            reconciliations: sameRentedFromItems[0].reconciliations,
            bundleItems: sameRentedFromItems[0].bundleItems,
            parentBundleItem: undefined,
            masterArticle: sameRentedFromItems[0].masterArticle,
            relatedArticle: sameRentedFromItems[0].relatedArticle,
          },
        ),
      )

      return reducedComplementary
    })
    .flat()
}

export const preProcessBundleItems = (orderItems: OrderItemInfo[]): OrderItemInfo[] => {
  const result: OrderItemInfo[] = []

  for (const orderItem of orderItems) {
    if (orderItem.bundleItems.length !== 0) {
      for (const bundleItem of orderItem.bundleItems) {
        result.push({
          manager: orderItem.manager,
          location: orderItem.location,
          orderItem: bundleItem,
          bundleItems: [],
          prolongations: orderItem.prolongations,
          reconciliations: orderItem.reconciliations,
          parentBundleItem: orderItem.orderItem,
          masterArticle: orderItem.masterArticle,
          relatedArticle: orderItem.relatedArticle,
        })
      }
    } else {
      result.push(orderItem)
    }
  }

  return result
}
